import React from 'react';
import { X } from 'lucide-react';

const Resume = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-slate-950">
      <div className="h-full w-full flex flex-col">
        {/* Header with close button */}
        <div className="flex items-center justify-between p-4 bg-slate-900 border-b border-slate-800">
          <h2 className="text-xl font-semibold text-white">Resume</h2>
          <button
            onClick={onClose}
            className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
            aria-label="Close resume"
          >
            <X size={24} />
          </button>
        </div>
        
        {/* PDF Embed */}
        <div className="flex-1 overflow-hidden">
          <iframe
            src="/SylviaJacobyResume.pdf"
            className="w-full h-full"
            title="Sylvia Jacoby Resume"
          />
        </div>
      </div>
    </div>
  );
};

export default Resume;

